import { useState } from 'react'
import { Overview } from './Overview'
import { Clients } from './Clients'
import { Sites } from './Sites'
import { Tunnels } from './Tunnels'

type Tab = 'overview' | 'clients' | 'sites' | 'tunnels'

const TABS: [Tab, string][] = [
  ['overview', 'Обзор'],
  ['clients', 'Клиенты'],
  ['sites', 'Сайты'],
  ['tunnels', 'Туннели'],
]

export function AdminPanel() {
  const [tab, setTab] = useState<Tab>('overview')
  return (
    <>
      <div className="section-title" style={{ marginBottom: 16 }}>
        <h2>Админ-панель</h2>
      </div>
      <div style={{ display: 'flex', gap: 6, marginBottom: 20, borderBottom: '1px solid var(--line)', flexWrap: 'wrap' }}>
        {TABS.map(([k, lbl]) => (
          <button
            key={k}
            onClick={() => setTab(k)}
            style={{
              padding: '8px 14px', border: 'none', background: 'transparent', cursor: 'pointer',
              color: tab === k ? 'var(--fg)' : 'var(--muted)', fontWeight: tab === k ? 600 : 400,
              fontSize: 14, borderBottom: `2px solid ${tab === k ? 'var(--accent)' : 'transparent'}`,
              marginBottom: -1,
            }}
          >
            {lbl}
          </button>
        ))}
      </div>

      {tab === 'overview' && <Overview />}
      {tab === 'clients' && <Clients />}
      {tab === 'sites' && <Sites />}
      {tab === 'tunnels' && <Tunnels />}
    </>
  )
}
